import {Injectable} from "@angular/core";
import {map} from "rxjs/operators";
import {DataService} from "../shared/data.service";
import {EMPTY, of} from "rxjs";
import {ApiEndpoints} from "../shared/ApiEndpoints";

@Injectable()
export class DeviceService extends DataService{

  /* DEVICE */

  getItems() {
    return this.getRequest(ApiEndpoints.devices);
  }

  getSimpleItems() {
    return this.getRequest(ApiEndpoints.devicessimple);
  }

  getDeviceFilters() {
    return this.getRequest(ApiEndpoints.devicefilters);
  }

  postFilters(filters) {
    return this.postRequest(ApiEndpoints.devicefilter, filters);
  }

  getDevice(id) {
    if (!id) {
      return of({error: 'Device id is missing'});
    }
    return this.getRequest(`${ApiEndpoints.device}/${id}`)
  }

  saveDevice(data, isPost) {
    if (isPost) {
      return this.postRequest(ApiEndpoints.device, data);
    } else {
      return this.putRequest(ApiEndpoints.device, data);
    }
  }

  getDeviceOptions() {
    return this.getRequest(ApiEndpoints.deviceOptions)
  }

  deleteDevice(id) {
    return this.deleteRequest(ApiEndpoints.device, id);
  }

  /* INFO */

  saveInfo(data) {
    return this.postRequest(ApiEndpoints.deviceInfo, data);
  }

  saveInfoList(list) {
    return this.postRequest(ApiEndpoints.deviceInfoList, list);
  }

  deleteInfo(id) {
    return this.deleteRequest(ApiEndpoints.deviceInfo, id);
  }

  /* TYPE */

  getTypes() {
    return this.getRequest(`${this.lang}/${ApiEndpoints.deviceTypes}`)
  }
  getType(id) {
    if (!id) {
      return of({error: 'Device type id is missing'});
    }
    return this.getRequest(`${this.lang}/${ApiEndpoints.deviceType}/${id}`)
  }

  saveType(data, isPost){
    if (isPost) {
      return this.postRequest(`${this.lang}/${ApiEndpoints.deviceType}`, data);
    } else {
      return this.putRequest(`${this.lang}/${ApiEndpoints.deviceType}`, data);
    }
  }

  deleteType(id){
    return this.deleteRequest(`${this.lang}/${ApiEndpoints.deviceType}`, id);
  }

  /* ATTRIBUTE */

  createAttribute(data, type) {
    if (!data || !type) {
      return of({error: 'Data or type missing.'});
    }
    return this.postRequest(`${ApiEndpoints.deviceAttribute}/${type}`, data);
  }

  updateAttribute(data) {
    if (!data.id) {
      return of({error: 'Missing attribute id'});
    }
    return this.putRequest(ApiEndpoints.deviceAttribute, data);
  }

  getAvailableAttributes(type) {
    if (!type) {
      return of({error: 'Missing type id'});
    }
    return this.getRequest(`${ApiEndpoints.availableDeviceAttribute}/${type}`)
  }

  getAttributes() {
    return this.getRequest(`${ApiEndpoints.deviceAttribute}`)
  }
  getAttribute(id) {
    if (!id) {
      return of({error: 'Device attribute id is missing'});
    }
    return this.getRequest(`${ApiEndpoints.deviceAttribute}/${id}`)
  }

  saveAttribute(data){
    if (data.id) {
      return this.putRequest(`${ApiEndpoints.deviceAttribute}`, data);
    } else {
      return this.postRequest(`${ApiEndpoints.deviceAttribute}`, data);
    }
  }

  deleteAttribute(id){
    return this.deleteRequest(`${ApiEndpoints.deviceAttribute}`, id);
  }

  saveAttributeConfig(type, attr) {
    if (!type || !attr || !attr.config) {
      return of({error: 'Missing type or attribute.'});
    }
    return this.postRequest(`${this.lang}/${ApiEndpoints.devicetypeConfig}`, {attr: attr.id, type: type.id, config: attr.config})
  }

  /* DATAPOINT */
  saveDatapoint(data) {
    return this.postRequest(ApiEndpoints.datapoint, data);
  }

  deleteDatapoint(id) {
    return this.deleteRequest(ApiEndpoints.datapoint, id);
  }

  getDeviceInfolist(device) {
    if (!device || !device.id) {
      return of({error: 'Device missing'})
    }
    return this.getRequest(`${ApiEndpoints.deviceInfoList}/${device.id}`)
  }
}
